import { createDisplayNameFactory, IAppConfig, IDisplayNameFactory } from '@omaze/app';

export const OMAZE_UI_CONFIG: IAppConfig = {
    COMPONENT_PREFIX: 'OmazeUI',
    FEATURE_FLAG_PREFIX: 'OmazeUI',
};

export const createDisplayName: IDisplayNameFactory = createDisplayNameFactory(OMAZE_UI_CONFIG);
